import React, { SetStateAction, useState } from "react";
import * as S from "./styles";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { useQueryParamsReducer } from "@/main/store/queryParams";
import { useNavigate } from "react-router-dom";
import Button from "@/main/components/shared/button/button";
import { useFormContext } from "react-hook-form";
import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import ModalConfirm from "@/main/components/shared/modalConfirm/modalConfirm";
import { PartCatalogSuggestionResponse } from "@/main/models/response/partCatalogResponse";
import { IInventoryRegisterForm } from "../utilsInventoryRegisterScreen";
import { ISectionVehiclesState } from "../sectionVehicles/sectionVehicles";

interface ISectionFooterProps {
	isLoadingSave: boolean;
	vehicles: ISectionVehiclesState[];
	suggestionFields: PartCatalogSuggestionResponse;
	setIsLoadingSave: React.Dispatch<SetStateAction<boolean>>;
	handleSubmitInventory: () => void;
}
function SectionFooter({
	isLoadingSave,
	vehicles,
	suggestionFields,
	handleSubmitInventory,
	setIsLoadingSave,
}: ISectionFooterProps) {
	const navigate = useNavigate();
	const { handleSubmit, getValues } = useFormContext<IInventoryRegisterForm>();
	const { queryParams: queryParamsReducer } = useQueryParamsReducer();
	const [isOpenModalDelete, setIsOpenModalDelete] = useState<boolean>(false);

	function handleBack() {
		let redirectRoute = RoutesConstants.inventorySearchImport;

		if (!isNullUndefined(queryParamsReducer.data)) {
			const nameKeyQueryParams = `${RoutesConstants.inventorySearchImport}_partsCatalogTab`;
			const queryParams = queryParamsReducer.data[nameKeyQueryParams];
			redirectRoute = queryParams
				? `${RoutesConstants.inventorySearchImport}?${new URLSearchParams(queryParams)}`
				: RoutesConstants.inventorySearchImport;
		}

		navigate(redirectRoute);
	}
	function handleSubmitInventoryValidation() {
		const formValues = getValues();
		const hasSuggestion = vehicles.some((vehicle) => vehicle.suggestion === true);

		if (
			formValues.category?.key == suggestionFields.guidCategory ||
			formValues.subCategory?.key == suggestionFields.guidSubCategory ||
			formValues.position?.key == suggestionFields.guidSubCategory ||
			formValues.xnuupPartId?.id == suggestionFields.xnuupId ||
			hasSuggestion
		) {
			setIsOpenModalDelete(true);
			return;
		}

		handleSubmitInventory();
	}

	function handleModalConfirm() {
		// setShowSuggestionIcon(true);
		setIsOpenModalDelete(false);
		handleSubmitInventory();
	}

	return (
		<S.FooterButtons>
			<SecondaryButton id="id-registerBodyshop-btn-back" type="button" onClick={handleBack}>
				{getTranslateByKey("information.back")}
			</SecondaryButton>
			<Button
				id="id-registerBodyshop-btn-save"
				type="button"
				isLoading={isLoadingSave}
				onClick={handleSubmit(handleSubmitInventoryValidation)}
			>
				{getTranslateByKey("information.save")}
			</Button>

			<KogModalFadeComponent
				open={isOpenModalDelete}
				setOpen={() => {
					setIsOpenModalDelete(false);
					setIsLoadingSave(false);
				}}
			>
				<ModalConfirm
					titleModal={getTranslateByKey("information.fieldSuggestionSave")}
					handleModalCancel={() => {
						setIsOpenModalDelete(false);
						setIsLoadingSave(false);
					}}
					handleModalConfirm={handleModalConfirm}
				/>
			</KogModalFadeComponent>
		</S.FooterButtons>
	);
}

export default SectionFooter;
